import { render, staticRenderFns } from "./DocsHome.vue?vue&type=template&id=e0677298"
import script from "./DocsHome.vue?vue&type=script&lang=js"
export * from "./DocsHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports